import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { translations } from "../translations";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("tamari-lang");
    return saved || "sq";
  });

  const t = translations[lang];

  useEffect(() => {
    localStorage.setItem("tamari-lang", lang);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
